import React from 'react';
import { gql } from '@apollo/client';
import { FunctionField, ReferenceField, Show, SimpleShowLayout, TextField } from 'react-admin';
import LinkField from 'components/LinkField';
import { scopeLabel } from 'utils/hrisMappingHelpers';

const HrisSpecialtyMappingShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <ReferenceField label="Company" source="company_id" reference="Company" link="show">
        <TextField source="name" />
      </ReferenceField>
      <FunctionField label="Scope" render={scopeLabel} />
      <ReferenceField
        label="Location"
        source="location_id"
        reference="Location"
        link="show"
        emptyText="-"
      >
        <TextField source="name" />
      </ReferenceField>
      <LinkField label="Specialty" source="specialty.label" />
      <TextField label="External ID" source="external_id" />
    </SimpleShowLayout>
  </Show>
);

HrisSpecialtyMappingShow.query = gql`
  query hrisSpecialtyMapping($id: Int!) {
    hrisSpecialtyMapping(id: $id) {
      id
      company_id
      location_id
      external_id
      specialty_id
      specialty {
        id
        label
        positions {
          id
        }
      }
    }
  }
`;

export default HrisSpecialtyMappingShow;
